import { questionnaireComponents } from "./components/index";
import { defineAsyncComponent } from "vue";
export default {
  install: (app) => {
    Object.entries(questionnaireComponents).forEach(([componentName, component]) => {
      app.component(componentName, defineAsyncComponent(component));
    });
  },
};
